"use client";

import { useState } from "react";
import { checkUserCoverageAreaSupport } from "../services";

export const useCoverageArea = (): {
  isAreaSupported: boolean;
  isLoading: boolean;
  error: string | null;
  checkCoverageArea: (latitude: number, longitude: number) => Promise<void>;
} => {
  const [isAreaSupported, setIsAreaSupported] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const checkCoverageArea = async (
    latitude: number,
    longitude: number,
  ): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await checkUserCoverageAreaSupport(
        latitude.toString(),
        longitude.toString(),
      );
      setIsAreaSupported(response.isSupported);
    } catch (err) {
      // eslint-disable-next-line no-console -- logger
      console.error("Error checking coverage area", err);
      setIsAreaSupported(false);
      setError("Area not supported or unable to check coverage");
    } finally {
      setIsLoading(false);
    }
  };

  return { isAreaSupported, isLoading, error, checkCoverageArea };
};
